import React from "react";
import BondRetrievalBillingInformation from "./BondRetrievalBillingInformation";
import { GoogleAutoComplete, LabeledCreatableSelect } from "./VABondRetrieveShared";

const VABillingInformationForm = (props) => (
  <BondRetrievalBillingInformation
    bondType="va"
    GoogleAutoComplete={GoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    {...props}
  />
);

export default VABillingInformationForm;
